var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE485",
    d: "M233.6,385.5c-5.9,10.4-2.1,21.6-2.5,32.4c-0.7,17.6-3.5,23.6-13.3,23.9c-10.2,0.4-13.9-6-13.9-24.2 c0-10.8,2.9-23-1.1-32c-4.3-9.6-18.7-7.8-28.3-12.1c-52-23.4-83-63-93.7-118.9c-1.3-6.8-0.2-9.3,7.6-10.4 c29.7-4.1,41.1-15.2,48.1-44.9c3.3-13.9,6.2-28,10.1-41.8c16-57.7,55.4-88.2,113.4-96.9c20.6-3.1,41.3-3.4,62.1-1.8 c-7.7,3.3-9.6,9.3-9.6,17.3c0.3,44.3,0.2,88.6,0.1,132.9c0,15.4-6.7,21.7-22.1,21.5c-4.4,0-8.8-0.5-13.1-0.7 c-26.3-0.9-51.7,2.7-75.1,15.4c-36.5,19.9-51.5,59.5-35.6,95.6C179.3,369.8,203,383.2,233.6,385.5z M250.5,159.2 c11.5-0.2,20.2-9.1,19.9-20.5c-0.3-11.3-9.7-20.4-20.7-20.2c-10.8,0.2-20.3,10.1-20.1,21C229.8,150.7,239,159.4,250.5,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E94D3D",
    d: "M233.6,385.5c-30.6-2.4-54.2-15.7-66.9-44.5c-15.9-36-0.9-75.7,35.6-95.6c23.4-12.8,48.9-16.4,75.1-15.4 c4.4,0.2,8.8,0.6,13.1,0.7c15.4,0.1,22-6.1,22.1-21.5c0.1-44.3,0.2-88.6-0.1-132.9c0-8,1.9-14.1,9.6-17.3 c27.1,1.6,54,4.5,80.3,11.4c6.8,1.8,14.6,2.8,16.8,11.4c2.3,8.7-4.3,13.1-9.4,17.8c-16.7,15.5-35.4,28.5-54.4,40.8 c-6.8,4.4-9.5,9.6-9.4,17.7c0.3,40.7-1.2,81.4,0.5,122c1.9,45.7-19.4,75.5-58.3,95.4c-9.2,2.9-18.3,5.8-27.5,8.8 C251.6,384.8,242.6,385.2,233.6,385.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE485",
    d: "M260.7,384.4c9.2-2.9,18.3-5.8,27.5-8.8c0,16.3,0,32.5,0,48.8c0,9.3-2.6,17.1-13.5,17.3 c-11,0.2-13.7-7.6-13.8-16.9C260.8,411.3,260.7,397.9,260.7,384.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332C33",
    d: "M250.5,159.2c-11.5,0.2-20.8-8.5-21-19.7c-0.2-10.9,9.3-20.8,20.1-21c11.1-0.2,20.4,8.9,20.7,20.2 C270.7,150.1,262.1,159.1,250.5,159.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.73e4e3d90abddb8ea2b9af6c99728bc8.svg";
export { ForwardRef as ReactComponent };